import request from '@/utils/request'

//获取实验筛选列表
export function getTemplate() {
  return request({
    url: '/apps/filter-template',
    method: 'get'
  })
}

//获取实验列表
export function getOnlineAppList(page,limit,data) {
  return request({
    url: data?('/apps?page='+page+'&limit='+limit+data):('/apps?page='+page+'&limit='+limit),
    method: 'get'
  })
}


//获取实验详情
export function getAppInfo(id){
  return request({
    url:'/apps/details?app_id='+id,
    method:'get'
  })
}

//获取实验打开次数
export function getAppCount(id){
  return request({
    url:'/apps/usages?app_platform_id='+id,
    method:'get'
  })
}


//提交试验记录

export function logApp(data){
  return request({
    url:'/apps/record-histories',
    method:'post',
    data
  })
}


//收藏实验

export function collectApp(data){
  return request({
    url:'/apps/collect',
    method:'post',
    data
  })
}


//获取实验收藏状态

export function getAppCollectStatus(data){
  return request({
    url:'/apps/collect?app_id='+data,
    method:'get'
  })
}

export function recordApp(data){
  return request({
    url:'/apps/record-usages',
    method:'post',
    data
  })
}

export function getHistory(day,page,limit){
  return request({
    url:'/apps/histories?days_ago='+(day||7)+'&page='+(page||1)+'&limit='+(limit||12),
    method:'get'
  })
}


export function getCollect(page,limit,selectRule){
  return request({
    url:selectRule?('/apps/favorites?page='+page+'&limit='+limit+selectRule):('/apps/favorites?page='+page+'&limit='+limit),
    method:'get'
  })
}

export function getJSON(key){
  return request({
    url:'/kv?key='+key,
    method:'get'
  })
}


export function getReportList(page,limit){
  return request({
    url:'/apps/user-all-lab-report?page='+page+'&limit='+limit,
    method:'get'
  })
}

export function getPCDownLoadInfo(protocol){
  if (protocol === 'http') {
    return request({
      url: `http://product.api.xiyilab.com/v1/system/appInfo/updateToLatest/xiyilab`,
      method: 'get'
    })
  }
  else {
    return request({
      url: `https://product.api.xiyilab.com/v1/system/appInfo/updateToLatest/xiyilab`,
      method: 'get'
    })
  }
}

export function getWXDownLoadInfo(protocol) {
  if (protocol === 'http') {
    return request({
      url: `http://product.api.xiyilab.com/v1/system/appInfo/updateToLatest/xiyilab-pc`,
      method: 'get'
    })
  }
  else {
    return request({
      url: `https://product.api.xiyilab.com/v1/system/appInfo/updateToLatest/xiyilab-pc`,
      method: 'get'
    })
  }
}

export function getXYYTJDownloadURL(protocol) {
  if (protocol === 'http') {
    return request({
      url: `http://product.api.xiyilab.com/v1/system/appInfo/updateToLatest/xiyilab-ytj`,
      method: 'get'
    })
  }
  else {
    return request({
      url: `https://product.api.xiyilab.com/v1/system/appInfo/updateToLatest/xiyilab-ytj`,
      method: 'get'
    })
  }
}

export function getXYJFDownloadURL(protocol) {
  if (protocol === 'http') {
    return request({
      url: `http://product.api.xiyilab.com/v1/system/appInfo/updateToLatest/xiyilab-of`,
      method: 'get'
    })
  }
  else {
    return request({
      url: `https://product.api.xiyilab.com/v1/system/appInfo/updateToLatest/xiyilab-of`,
      method: 'get'
    })
  }
}

export function getYDKTDownloadURL(protocol) {
  if (protocol === 'http') {
    return request({
      url: `http://product.api.xiyilab.com/v1/system/appInfo/updateToLatest/ydkt-client`,
      method: 'get'
    })
  }
  else {
    return request({
      url: `https://product.api.xiyilab.com/v1/system/appInfo/updateToLatest/ydkt-client`,
      method: 'get'
    })
  }
}
export function getYDKT32DownloadURL(protocol) {
  if (protocol === 'http') {
    return request({
      url: `http://product.api.xiyilab.com/v1/system/appInfo/updateToLatest/ydkt-client-32`,
      method: 'get'
    })
  }
  else {
    return request({
      url: `https://product.api.xiyilab.com/v1/system/appInfo/updateToLatest/ydkt-client-32`,
      method: 'get'
    })
  }
}
